import { UserProfile } from 'constants/interface';
import React from 'react';
import { Avatar, Spinner } from 'UI';

import {
  MainContainer,
  AvatarContainer,
  LogoutButton,
} from './style';

const getUserInitials = (name?: string) => (
  name
    ?.split(' ')
    .map((partName) => partName[0])
    .filter((initial): initial is 'string' => !!initial)
    .reduce((fullInitials, curInitial) => (fullInitials + curInitial), '')
    ?.slice(0, 2)
);

interface UserMenuProps {
  user?: UserProfile
  logout?(): void
  isLoading?: boolean
}

const UserMenu = ({
  user,
  logout,
  isLoading,
}: UserMenuProps): JSX.Element => (
  <MainContainer>
    <AvatarContainer>
      <Avatar size={64}>
        {isLoading ? <Spinner /> : getUserInitials(user?.name)}
      </Avatar>
    </AvatarContainer>
    <LogoutButton type="button" onClick={logout} disabled={isLoading}>Sair</LogoutButton>
  </MainContainer>
);

UserMenu.defaultProps = {
  user: {},
  logout: () => {},
  isLoading: false,
};

export default UserMenu;
